// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1R0OG","inner":"Footer_inner__2bI5Z"};